import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'antd';
import { usePhaserConfig } from '../contexts/PhaserConfigContext';
import { TScene } from '../../../models/objects/objects';
import { getImagePath } from '../../../utils/format/valueFormat';

interface SceneConfiguratorProps {
    scenesConfig: TScene[];
}

const SceneConfigurator: React.FC<SceneConfiguratorProps> = ({ scenesConfig }) => {
    const { scene, updateScene } = usePhaserConfig(); // Accéder à la configuration de la scène 
    const [selectedSceneId, setSelectedSceneId] = useState<number | null>(null); // Scène sélectionnée

    // Synchroniser les états locaux avec la configuration actuelle
    useEffect(() => {
        const foundScene = scenesConfig.find((sc) => sc.img === scene.background?.image);
        setSelectedSceneId(foundScene ? foundScene.id : null);
    }, [scene, scenesConfig]);

    // Gérer la sélection d'une scène et sauvegarder immédiatement
    const handleSceneSelect = (sceneId: number) => {
        const selectedScene = scenesConfig.find((sc) => sc.id === sceneId);
        if (!selectedScene) return;

        setSelectedSceneId(sceneId);
        updateScene({
            id: `scene_${selectedScene.id}`,
            width: scene.width,  // On garde la taille actuelle de la scène
            height: scene.height,
            background: {
                image: selectedScene.img,
                mode: scene.background?.mode || 'cover',
            },
        });
    };

    return (
        <div>
            <Row gutter={[16, 16]}>
                {scenesConfig.map((sc) => (
                    <Col key={sc.id} span={6}>
                        <Button
                            onClick={() => handleSceneSelect(sc.id)}
                            style={{
                                width: '100px',
                                height: '100px',
                                padding: 0,
                                borderRadius: '8px',
                                backgroundImage: `url(${getImagePath(sc.img)})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                border: selectedSceneId === sc.id ? '3px solid #1890ff' : '1px solid #ccc',
                                transition: 'border 0.2s ease-in-out'
                            }}
                        />
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default SceneConfigurator;
